export const SET_FORM_UPLOAD_IMAGE = "SET_FORM_UPLOAD_IMAGE";
export const SET_ADDRESS_COMPONENTS = "SET_ADDRESS_COMPONENTS";
export const SET_GOOGLE_MAP_FIELDS = "SET_GOOGLE_MAP_FIELDS";